<template>
	<div
		:style="
			isFlipped
				? { backgroundColor: '#FAF4EA' }
				: { backgroundColor: '#ffffff' }
		"
		class="question-item"
		@click="isFlipped = !isFlipped"
	>
		<div :class="['question-item__header', { flipped: isFlipped }]">
			<p class="question-item__title" v-html="question"></p>
			<button
				class="question-item__button"
				:class="{ flipped__icon: isFlipped }"
			>
				<svg width="24" height="24">
					<use
						:xlink:href="
							isFlipped ? 'sprite.svg#down-light' : 'sprite.svg#down-dark'
						"
					></use>
				</svg>
			</button>
		</div>
		<div v-show="isFlipped" class="question-item__content">
			<div class="question-item__content-label">
				Роль ОМСУ/МКУ, МОУ (с правами на чтение и запись)
			</div>
			<div class="question-item__content-instruction">
				<div
					v-for="(step, indx) in instructions"
					:key="indx"
					class="question-item__content-instruction--item"
				>
					<div class="question-item__content-instruction--item-text">
						<p class="question-item__content-instruction--item-title">
							{{ step.title }}
						</p>
						<p v-for="(text, index) in step.text" :key="index">
							{{ text }}
						</p>
					</div>
					<img v-if="step.image" :src="step.image" alt="image" />
					<div
						v-if="step.label"
						style="margin-top: 36px"
						class="question-item__content-label"
					>
						ИЛИ
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from "vue";

const isFlipped = ref(false);

defineProps({
	question: {
		type: String,
		required: true,
	},
	instructions: {
		type: Array,
		required: true,
	},
});
</script>

<style lang="scss">
@import "./EpkQuestion.scss";
</style>
